module.exports = __webpack_public_path__ + "static/media/step_006.d7c2ac70.jpeg";